import { render, staticRenderFns } from "./orderStatusAndList.vue?vue&type=template&id=898de638&scoped=true"
import script from "./orderStatusAndList.vue?vue&type=script&setup=true&lang=js"
export * from "./orderStatusAndList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./orderStatusAndList.vue?vue&type=style&index=0&id=898de638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898de638",
  null
  
)

export default component.exports